import { FulfillmentState, OperatorPlaySoundMode } from "@/data/model/Enums";
import type { IFulfillmentChangedEvent } from "@/data/model/Events";
import type { IOperatorFulfillment } from "@/data/model/Operator";



import { logError } from "@/shared/logging/errors";



import { OperatorClient } from "@/operator/OperatorClient";


export class FulfillmentSoundNotifications {
    // an added fulfillment comes as is, a changed one carries the state it had before the change
    public static playSoundIfNeeded(fulfillment: IOperatorFulfillment | IFulfillmentChangedEvent) {
        const previousState = "previousState" in fulfillment ? fulfillment.previousState : undefined;

        // a change that did not move the fulfillment to another state (e.g. a new queue position) stays silent
        if (previousState === fulfillment.state) return;
        // a fulfillment that shows up already ready or fulfilled is not news
        if (previousState === undefined && fulfillment.state !== FulfillmentState.InPreparation) return;

        const operatorPlaySoundModes = OperatorClient.context.settings?.operatorPlaySoundModesList;

        switch (fulfillment.state) {
            case FulfillmentState.InPreparation:
                if (operatorPlaySoundModes == null || operatorPlaySoundModes.some((c) => c === OperatorPlaySoundMode.FulfillmentInPreparation) === true) {
                    SoundNotifications.playNewOrderSound();
                }
                break;
            case FulfillmentState.Ready:
                if (operatorPlaySoundModes?.some((c) => c === OperatorPlaySoundMode.FulfillmentReady) === true) {
                    SoundNotifications.playNewOrderSound();
                }
                break;
            case FulfillmentState.Fulfilled:
                if (
                    !fulfillment.isPaid &&
                    operatorPlaySoundModes?.some((c) => c === OperatorPlaySoundMode.FulfillmentFulfilledNotPaid) === true
                ) {
                    SoundNotifications.playNewOrderSound();
                }
                break;
        }
    }
}

export class SoundNotifications {
    private static playing = false;
    private static isOlderIOS = SoundNotifications.checkIfOlderIOS();

    constructor() {}

    private static checkIfOlderIOS(): boolean {
        try {
            const audio = new Audio();
            audio.volume = 0.9;
            // volume cannot be changed from "1" on iOS 12 and below
            if (audio.volume === 1 && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
                return true;
            }

            return false;
        } catch (ex) {
            logError(ex);
            // it's better to assume we should use max volume
            return true;
        }
    }

    public static playNewOrderSound() {
        try {
            if (SoundNotifications.playing) return; // Exit if sound is already playing

            console.log("SOUND!!!");
            const audio = new Audio("/assets/img/operator/13752-bells_call_2.mp3");
            audio.volume = SoundNotifications.isOlderIOS ? 1 : 0.9; // Set appropriate volume level

            SoundNotifications.playing = true; // Set `playing` to true when playback starts

            audio.play().catch(() => {
                SoundNotifications.playing = false; // Reset `playing` in case of an error
            });

            // Reset `playing` after 2 seconds to allow new playback requests
            setTimeout(() => {
                SoundNotifications.playing = false;
            }, 2000);
        } catch (ex) {
            logError(ex);
            SoundNotifications.playing = false;
        }
    }
}
